/*
  Created
    by: Upendram Reddy Tanuja
    on: 05-Aug-2019 12:30 PM
    purpose: Profile Settings component
    comments: Profile Setting details
*/

import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { ProfileSettings } from '../../../classes/shared/profile-settings/profile-settings';
import { Subscription } from 'rxjs';
import { ProfileSettingsService } from '../../../services/shared/profile-settings/profile-settings.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserImageCropperComponent } from '../user-image-cropper/user-image-cropper.component';
import { StandardFile } from '../../../controls/classes/file/file';
import { NotificationService } from '../../../controls/services/notification/notification.service';
import { WorkbenchService } from '../../../services/ATS/workbench/workbench.service';
import { cloneArray } from '../../../app.component';
import { prepareSections } from 'src/app/controls/components/dynamic-form/dynamic-form.component';
import { SessionService } from '../../../services/session/session.service';
import { RoutesService } from '../../../services/shared/routes/routes.service';

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss'],
  providers: [
    ProfileSettingsService,
    WorkbenchService
  ]
})
export class ProfileSettingsComponent implements OnInit {
  FileName;
  profile_settings_form: UntypedFormGroup;
  default_imgs: any = "assets/profile-pic.jpg";
  image_guid;
  // flag;
  imgs: any;
  section_data;
  dynamic_form: UntypedFormGroup | any = {};
  display_type: number;
  dataSavedRef: Function;
  attachment_id: number;
  // images: any = "data:image/jpeg;base64," + this.imgs;
  profile_settings = new ProfileSettings;
  profile_settings_backup = new ProfileSettings;
  files = new StandardFile();
  route_subscription: Subscription;
  master = [];
  profile_list: any = {};
  user_type: any = [];
  masters = [];
  data_profile: any = {};
  user_id: number;
  init() {
    this.default_imgs = "assets/user-profile.jpg";
    this.imgs = '';
    this.attachment_id = 0;
    this.profile_settings = new ProfileSettings();
    this.profile_settings_backup = new ProfileSettings();
    this.files = new StandardFile();

    this.profile_settings_form = new UntypedFormGroup(
      {
        short_signature: new UntypedFormControl(''),
        long_signature: new UntypedFormControl(''),
        assign_to: new UntypedFormControl(null),
        time_zone_id: new UntypedFormControl(null),
        extension_number: new UntypedFormControl(null),
        mobile_no_cc: new UntypedFormControl(null),
        mobile_no: new UntypedFormControl(null),
      });
  }

  constructor(
    private profile_Setting_Service: ProfileSettingsService,
    private routes_service: RoutesService,
    private router: Router,
    private activated_route: ActivatedRoute,
    private dialog: MatDialog,
    private modalService: NgbModal,
    private _session: SessionService,
    public dialogRef: MatDialogRef<ProfileSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private notification_svc: NotificationService,
    private change_detector: ChangeDetectorRef,
    private workbench: WorkbenchService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.dynamic_form = new UntypedFormGroup({});
    this.init();
    this.getProfileDetails();
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';

  //ckeditor  used for  Long Signature
  public onReady(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
  }


  filechange(event: any): void {
    this.imageChangedEvent = event;
    this.cropImage();
  }

  getProfileDetails() {
    this.profile_Setting_Service.getProfileDetails().subscribe(res => {

      if (res && res['data']) {
        if (res['data'].masters) {
          if (res['data'].masters.assign_to) {
            this.master['assign_to'] = res['data'].masters.assign_to || [];
          }
          if (res['data'].masters.time_zone) {
            this.master['time_zone'] = res['data'].masters.time_zone || [];
          }
          if (res['data'].masters.isd) {
            this.master['isd'] = res['data'].masters.isd || [];
          }
        }
        if (res['data'].details) {
          this.attachment_id = 0;
          this.profile_list = res['data'].details;
          if (res['data'].details.user_type) {
            if (typeof res['data'].details.user_type == 'string') {
              this.user_type = JSON.parse(res['data'].details.user_type);
            }
            else {
              this.user_type = res['data'].details.user_type;

            }
          }
          this.profile_settings.setData(res['data'].details);
          this.data_profile = res['data'].details;
          if (this.profile_settings && this.profile_settings.files && this.profile_settings.files.attachment_id) {
            this.attachment_id = this.profile_settings.files.attachment_id;
          }
          // this.profile_settings_form.setValue(this.profile_settings.getFormGroupData());
          this.getDetails();
        }
      }
    });
  }
  getDetails(flag?) {
    this.workbench.getFormDetails({ form_code: 9997, t_id: 0, template_code: 0 }).subscribe(res => {
      if (res && res['data'] && res['data']['details'] && res['data']['details'].length) {
        this.section_data = res['data']['details'];

        this.section_data[0].data = this.data_profile;

        if (res['data']['details'][0]) {
          this.display_type = res['data']['details'][0].display_type_id;
        }
      }
      else {
        this.notification_svc.success(res['message'], 'Close', 5000);
      }
    })
    if (!flag) {

      let virtual_scroll_fields = {};
      prepareSections(this.section_data, this.dynamic_form, this.section_data, null, this.fb, this.display_type, virtual_scroll_fields);

      let master_obj = [];
      for (let i = 0; i < Object.keys(virtual_scroll_fields).length; i++) {
        let obj = {}
        let master_id = Object.keys(virtual_scroll_fields)[i];
        obj['master_id'] = master_id;
        obj['values'] = virtual_scroll_fields[master_id];
        master_obj.push(obj);
      }
      this.workbench.getFormMaster(master_obj, { form_code: 9997, t_id: 0, template_code: 0 }).subscribe(masters => {
        this.masters = masters['data'].masters;
        this.change_detector.detectChanges();
      })
    }

  }
  cropImage() {
    let modalService = this.modalService;
    const reader = new FileReader();
    reader.readAsDataURL(document.getElementById('file-input')['files'][0]);
    let file = document.getElementById('file-input')['files'][0];
    let image_file = new StandardFile();
    reader.onload = (e) => {
      const modal = modalService.open(UserImageCropperComponent, {
        backdrop: 'static',
        keyboard: false,
        size: 'lg'
      });
      (modal.componentInstance).imageChangedEvent = this.imageChangedEvent;
      (modal.componentInstance).aspectRatio = 1 / 1;
      (modal.componentInstance).crop_flag = 1;
      modal.result.then(result => {

        this.croppedImage = result;

        // if (this.croppedImage !== undefined) {
        this.imgs = result;
        // this.flag = 0;
        if (result) {
          this.attachment_id = 0;
        }
        image_file.setFileDetails(file.name, file.type, result, file.name.split('.')[1], 1, 0, file.size, 1, null);
        this.profile_settings.files = image_file;
        // }
      },
        err => {
          //
          // document.getElementById('file-input')['value'] = null;
          //
        })
    };
    reader.onerror = function () {

    };
  }


  cancelProfile() {
    this.dialogRef.close();
  }

  saveProfile() {
    // this.profile_settings.setFormGroupData(this.profile_settings_form.value);
    // this.profile_settings.user_id = this._session.getUserId();

    // this.profile_Setting_Service.saveProfileDetails(this.profile_settings).subscribe(res => {

    //   if (res['data']) {
    //     this.notification_svc.successSnackbar(res['message'], 'Cancel', 5000);
    //     this.dialogRef.close();
    //   }
    // })
    if (this.section_data && this.section_data.length) {
      this.data_profile = Object.assign({}, this.dynamic_form.get([this.section_data[0].section_id]).value);
      this.data_profile['files'] = this.profile_settings.files;
      this.data_profile['user_id'] = this.profile_list.user_id;
      this.data_profile['update_flag'] = 1;
      this.profile_Setting_Service.saveProfileDetails(this.data_profile).subscribe(res => {
        if (res['data']) {
          this.notification_svc.success(res['message'], 'Cancel', 5000);
          this.dialogRef.close();
        }
        else {
          this.notification_svc.success(res['message'], 'Close', 5000);
        }
      })
    }
  }


}
